import { Col, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import {
  createEmailAccount,
  createEmailAccountSuccess,
  createEmailDomain,
  createEmailDomainSuccess,
  emailDomainList,
  getEmailAccountList,
  updateEmailAccount,
  updateEmailAccountSuccess,
} from "../../../store/actions";
import AppModal from "../../Common/AppModal";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import DnsRecordsPanel from "../../Common/DnsRecordsPanel/DnsRecordsPanel";
export default function CreateNewEmailDomain({
  modal,
  setModal,
  toggle,
  isEdit,
  updateData,
}) {
  const dispatch = useDispatch();
  // get from local storage
  const defaultCompanyName = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.Company_BusinessName;
  const defaultData = {
    DomainUrl: "",
  };
  const [createUpdateData, setCreateUpdateData] = useState(defaultData);
  useEffect(() => {
    if (isEdit) return;
    setCreateUpdateData(defaultData);
  }, [isEdit]);

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateData)) return;
    setCreateUpdateData(defaultData);
  }, [isEdit, updateData]);

  const handleCreateUpdate = (type) => {
    if (type === "create") {
      dispatch(createEmailDomain([createUpdateData]));
    }
    if (type === "update") {
      dispatch(updateEmailAccount([createUpdateData]));
    }
  };

  const {
    emailAccountsCreateAPI,

    emailAccountsCreateLoading,
  } = useSelector((state) => ({
    emailAccountsCreateAPI: state.EmailInbound.emailDomainCreate,

    emailAccountsCreateLoading: state.EmailInbound.emailDomainCreateLoading,
  }));

  // Task 24333 — the create response carries the DNS records that prove
  // ownership. Hold them and show them instead of closing the modal, otherwise
  // the user is never told what to publish.
  const [dnsRecords, setDnsRecords] = useState([]);
  const [createdDomain, setCreatedDomain] = useState("");

  //Create Email Account response
  useEffect(() => {
    if (isEmpty(emailAccountsCreateAPI)) return;
    if (emailAccountsCreateAPI?.status === 200) {
      toast.success(emailAccountsCreateAPI.message);
      dispatch(emailDomainList());
      const records = emailAccountsCreateAPI?.emaildomaindnsrecord_list;
      if (!isEmpty(records)) {
        setCreatedDomain(createUpdateData?.DomainUrl);
        setDnsRecords(records);
      } else {
        setModal(false);
      }
    } else {
      toast.error(emailAccountsCreateAPI.message);
    }
    dispatch(createEmailDomainSuccess([]));
  }, [emailAccountsCreateAPI]);

  // Step 2 of the add flow: the domain exists, now show what to publish.
  if (!isEmpty(dnsRecords)) {
    return (
      <AppModal
        open={modal}
        onClose={toggle}
        title="Verify you own this domain"
        icon={<EmailOutlinedIcon />}
        headerAccent="indigo"
        size="lg"
        onSubmit={() => setModal(false)}
        submitLabel="Done"
        submitColor="success"
      >
        <p className="mb-2">
          <strong>{createdDomain}</strong> has been added. To prove your
          business owns it, publish the records below, then use{" "}
          <strong>Verify</strong> on the domain in the list.
        </p>
        <DnsRecordsPanel records={dnsRecords} />
      </AppModal>
    );
  }

  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={isEdit ? "Update Email Domain" : "Add Email Domain"}
      icon={<EmailOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={emailAccountsCreateLoading}
      loadingText="Saving…"
      onSubmit={() =>
        isEdit ? handleCreateUpdate("update") : handleCreateUpdate("create")
      }
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
    >
      <Row className="g-3">
        <Col lg={12}>
          <div>
            <div className={"pt-2"}>
              <div>
                <label>Email Domains</label>
              </div>
              <div className={"mt-2"}>
                <label>Domain Url</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="DomainUrl"
                  value={createUpdateData.DomainUrl}
                  onChange={(e) =>
                    setCreateUpdateData({
                      ...createUpdateData,
                      DomainUrl: e.target.value,
                    })
                  }
                />
              </div>{" "}
            </div>
          </div>
        </Col>
      </Row>
    </AppModal>
  );
}
